import { render, staticRenderFns } from "./feSection.vue?vue&type=template&id=b41c2a38&"
import script from "./feSection.vue?vue&type=script&lang=js&"
export * from "./feSection.vue?vue&type=script&lang=js&"
import style0 from "./feSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports